module.exports = __webpack_public_path__ + "static/img/r-1-2-icon.ffb52a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/en/role-1/r-1-2-icon.png
// module id = tWnm
// module chunks = 0